import { render } from "./GerarCartaProposta.vue?vue&type=template&id=64a71ac2&scoped=true"
import script from "./GerarCartaProposta.vue?vue&type=script&lang=js"
export * from "./GerarCartaProposta.vue?vue&type=script&lang=js"

import "./GerarCartaProposta.vue?vue&type=style&index=0&id=64a71ac2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a71ac2"]])

export default __exports__